import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import {GlobalModule} from '../../../../../app/global-module/global-module.module';

import { IonicModule } from '@ionic/angular';

import { DealPage } from './deal.page';

const routes: Routes = [
  {
    path: '',
    component: DealPage
  }
];

@NgModule({
  imports: [
    GlobalModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [DealPage]
})
export class DealPageModule {}
